import { useContext } from 'react'
import { RepeatTaskContext, RepeatTaskContextType } from './RepeatTaskProvider'

// Hook to access the repeat task context
export function useRepeatTask(): RepeatTaskContextType {
  const context = useContext(RepeatTaskContext)
  if (!context) {
    throw new Error('useRepeatTask must be used within RepeatTaskProvider')
  }
  return context
}
